/**
 * @file コンポーネント：フル動画ページ機器広告スライダー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledSlider = styled.div`
    position: relative;
    height: 100%;

    &.is-covered {
        &::before {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: ${zIndex.sliderCover};
            width: 100%;
            height: 100%;
            content: "";
        }
    }

    &.is-zoom {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: fixed;
        top: 64px;
        left: 0;
        z-index: ${zIndex.sliderZoomContent};
        width: 100%;
        height: calc(100% - 64px);
        padding: 16px;
        background-color: rgba(0, 0, 0, 0.4);

        img {
            max-width: unset;
            max-height: unset;
        }
    }
`;

export const StyledSliderActionlist = styled.ul`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: ${zIndex.sliderZoomButton};

    &.is-zoom {
        position: static;
    }
`;

export const StyledSliderActionlistButton = styled.button`
    width: 44px;
    height: 44px;
    padding: 0;
    border: none;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明の黒背景 */
    border-radius: 50%; /* 丸いボタン */
    color: #ffffff;
    font-size: 18px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

    &[disabled] {
        color: #acadae;
        background-color: rgba(0, 0, 0, 0.3);
        text-shadow: none;
        cursor: default;
        pointer-events: none;
    }

    ${mediaQuery.sp(`
        width: 28px;
        height: 28px;
    `)};
`;

export const StyledSliderActionlistItem = styled.li`
    &:last-of-type {
        margin-left: 16px;
    }

    &:first-of-type {
        margin-left: 0;
    }
`;

export const StyledSliderArrow = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    padding: 0;

    ${mediaQuery.sp(`
        width: 28px;
        height: 28px;
    `)};
`;

// 左矢印（prev）
export const StyledSliderArrowPrev = styled(StyledSliderArrow)`
    left: 5px;
    background-image: url("data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' fill='white'/></svg>");

    ${mediaQuery.sp(`
        left: 0px;
    `)};
`;

// 右矢印（next）
export const StyledSliderArrowNext = styled(StyledSliderArrow)`
    right: 5px;
    background-image: url("data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z' fill='white'/></svg>");

    ${mediaQuery.sp(`
        right: 0px;
    `)};
`;

// 非アクティブ状態（透明度を下げてクリック無効）左矢印（prev）
export const StyledSliderArrowInactivePrev = styled(StyledSliderArrow)`
    left: 5px;
    opacity: 0.3;
    pointer-events: none;

    ${mediaQuery.sp(`
        left: 0px;
    `)};
`;

// 非アクティブ状態（透明度を下げてクリック無効）右矢印（next）
export const StyledSliderArrowInactiveNext = styled(StyledSliderArrow)`
    right: 5px;
    opacity: 0.3;
    pointer-events: none;

    ${mediaQuery.sp(`
        right: 0px;
    `)};
`;

export const StyledSliderArrowlist = styled.ul``;

export const StyledSliderArrowlistItem = styled.li`
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    z-index: ${zIndex.sliderArrow};
    height: 100%;
`;

export const StyledSliderArrowlistItemLeft = styled(StyledSliderArrowlistItem)`
    left: 0;
`;

export const StyledSliderArrowlistItemRight = styled(StyledSliderArrowlistItem)`
    right: 0;
`;

export const StyledSliderButton = styled.a`
    display: block;
    min-width: 88px;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;

    &[data-button-type="cancel"] {
        background-color: #ffffff;
        color: #25292d;
    }

    &[data-button-type="submit"] {
        background-color: #c31a1e;
        color: #ffffff;
    }
`;

export const StyledSliderButtonlist = styled.ul`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`;

export const StyledSliderButtonlistItem = styled.li`
    margin-right: 4px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledSliderContainer = styled.div`
    position: relative;
    overflow: hidden;
`;

export const StyledSliderContentlist = styled.ul`
    height: 100%;
    overflow: auto;
`;

export const StyledSliderContentlistItem = styled.li`
    display: none;

    &.is-current {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const StyledSliderContentWrapper = styled.div`
    height: 100%;
`;

export const StyledSliderDot = styled.button`
    width: 12px;
    height: 12px;
    padding: 0;
    border: none;
    border-radius: 50%;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background-color: #acadae;
    line-height: 1;
`;

export const StyledSliderDotInactive = styled.button`
    width: 12px;
    height: 12px;
    padding: 0;
    border: none;
    border-radius: 50%;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background-color: rgba(255, 255, 255, 0.87);
    line-height: 1;
    pointer-events: none;
`;

export const StyledSliderDotlist = styled.ul`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 12px;
`;

export const StyledSliderDotlistItem = styled.li`
    margin: 0 4px;
`;
